<div>

    <div class="d-flex justify-content-end align-items-center">
        <button class="btn btn-info text-left m-2" (click)="addRow()">
            Add rows
        </button>
    </div>


    <table class="table table-fixed  table-striped table-bordered table-hover">
        <thead>
          <tr>
            <th scope="col">No.</th>
            <th scope="col">Year</th>
            <th scope="col">Calender Period</th>
            <th scope="col">Income</th>
            <th scope="col">Expense</th>
            <th scope="col">Assets</th>
            <th scope="col">Liability</th>
            <th scope="col">Net Profit</th>
            <th scope="col">No of Clients</th>
            <th scope="col">Unit Rate</th>
            <th scope="col">Client Location</th>
          </tr>
        </thead>
        <tbody class="table-group-divider">
          <tr *ngFor="let row of rows; let i = index">
            <td >
                {{i+1}}
            </td>
            <th scope="row">
                <input
                type="number"
                [(ngModel)]="row.year"
                placeholder="Enter year"
              />
            </th>
            <td>
              <input
                type="number"
                [(ngModel)]="row.calender"
                placeholder="Enter calender"
              />
            </td>
            <td>
                <input
                  type="number"
                  [(ngModel)]="row.income"
                  (input)="changedValue(i)"
                  placeholder="Enter income"
                />
              </td>
              <td>
                <input
                  type="number"
                  [(ngModel)]="row.expense"
                  (input)="changedValue(i)"
                  placeholder="Enter value"
                />
              </td>
              <td>
                <input
                  type="number"
                  [(ngModel)]="row.assets"
                  (input)="changedValue(i)"
                  placeholder="Enter value"
                />
              </td>
              <td>
                <input
                  type="number"
                  [(ngModel)]="row.liability"
                  (input)="changedValue(i)"
                  placeholder="Enter value"
                />
              </td>
              <td>
                <input
                  type="number"
                  [(ngModel)]="row.profit"
                  (input)="changedValue(i)"
                  placeholder="Enter value"
                />
              </td>
            <td>
              <input
                type="number"
                [(ngModel)]="row.clients"
                (input)="changedValue(i)"
                placeholder="Enter value"
              />
            </td>
            <td>
                <input
                  type="number"
                  [(ngModel)]="row.unitRate"
                  (input)="changedValue(i)"
                  placeholder="Enter value"
                />
            </td>
            <td>
                <input
                  type="text"
                  [(ngModel)]="row.clientLocation"
                  (input)="changedValue(i)"
                  placeholder="Enter location"
                />
            </td>

            <td class="d-flex justify-content-center align-items-center"> 
				<button class="btn btn-danger" (click) = "deleteRow(i)">
					<i class="fa fa-trash"></i>
				</button>
			</td>
        
          </tr>
        </tbody>

        <tfoot>
            <tr>

              <th colspan="3">Average</th>
              <td >{{ calculateIncome() | number: '1.2-2' }}</td>
              <td>{{calculateExpense()| number: '1.2-2'}}</td>
              <td>{{calculateAssets()| number: '1.2-2'}}</td>
              <td>{{calculateLiability()| number: '1.2-2'}}</td>
              <td>{{calculateProfit()| number: '1.2-2'}}</td>
              <td>{{calculateClients()| number: '1.2-2'}}</td>
              
            </tr>
        </tfoot>


      </table>
</div>



